import { Box } from '@mui/material';
import { Button } from '@qrios/frontend-library';

import { convertToKebabCase } from '../../../constants/helpers/text';

type ActionHandler = (props: unknown) => unknown;

interface ButtonType {
  text: string;
  handler: ActionHandler;
  type: 'button';
}

interface SubmitType {
  text: string;
  type: 'submit';
}

interface Actions {
  primary: ButtonType | SubmitType;
  secondary?: ButtonType;
}

interface Props {
  actions: Actions;
  loading?: boolean;
  danger?: boolean;
}

export const DialogActionButtons = ({ actions, danger, loading = false }: Props) => {
  const PrimaryButton = (
    <Box width={actions.secondary ? '50%' : '100%'} ml={actions.secondary ? 1 : 0}>
      <Button
        fullWidth
        text={actions.primary.text}
        onClick={actions.primary.type === 'button' ? actions.primary.handler : undefined}
        loading={loading}
        type="submit"
        danger={danger}
        data-testid={`button-${convertToKebabCase(actions.primary.text)}`}
      />
    </Box>
  );

  const SecondaryButton = actions.secondary ? (
    <Box width="50%" mr={1}>
      <Button
        fullWidth
        text={actions.secondary.text}
        variant="outlined"
        onClick={actions.secondary.handler}
        data-testid={`button-${convertToKebabCase(actions.secondary.text)}`}
      />
    </Box>
  ) : null;

  return (
    <Box display="flex" mt={2}>
      {SecondaryButton}
      {PrimaryButton}
    </Box>
  );
};
